import React, { useEffect } from "react";
import { Drawer, Form, Input, Switch, Button, Spin } from "antd";
import { Typography } from "antd";

const { Text } = Typography;

const ApplicationDrawer = ({
  visible,
  onClose,
  onSubmit,
  application,
  loading,
}) => {
  const [form] = Form.useForm();

  // populate form when editing
  useEffect(() => {
    if (application) {
      form.setFieldsValue({
        name: application.name,
        code: application.code,
        description: application.description,
        active: application.active,
      });
    } else {
      form.resetFields();
    }
  }, [application, form]);

  const handleFinish = (values) => {
    const payload = {
      name: values.name,
      description: values.description,
      active: values.active || false,
    };

    // only include code when creating
    if (!application) {
      payload.code = values.code;
    }

    onSubmit(payload);
    form.resetFields();
  };

  return (
    <Drawer
      title={
        <span style={{ fontFamily: "Inter", fontSize: 15 }}>
          {application ? "Edit Application" : "Create Application"}
        </span>
      }
      size={520}
      zIndex={99999}
      onClose={onClose}
      open={visible}
      styles={{ body: { paddingBottom: 80 } }}
      footer={
        <div style={{ textAlign: "right" }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => form.submit()}>
            Submit
          </Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        <Form layout="vertical" form={form} onFinish={handleFinish}>
          <Form.Item
            label="Application Name"
            name="name"
            rules={[
              { required: true, message: "Please enter application name" },
            ]}
          >
            <Input placeholder="Enter application name" />
          </Form.Item>

          <Form.Item
            label="Code"
            name="code"
            rules={[
              {
                required: !application,
                message: "Please enter application code",
              },
            ]}
          >
            <Input
              placeholder="Enter application code"
              disabled={!!application}
            />
          </Form.Item>

          <Form.Item label="Description" name="description">
            <Input.TextArea placeholder="Enter description" />
          </Form.Item>

          <Form.Item label="Active" name="active" valuePropName="checked">
            <Switch />
          </Form.Item>

          {/* client ID display (only when editing) */}
          {application && (
            <Form.Item label="Client ID">
              <Text
                copyable={{
                  text: application.clientId,
                  tooltips: ["Copy Client ID", "Copied!"],
                }}
                style={{
                  display: "inline-block",
                  padding: "6px 10px",
                  border: "1px solid #d9d9d9",
                  borderRadius: 4,
                  width: "100%",
                  //   fontFamily: "monospace",
                  fontSize: 12,
                  background: "#fafafa",
                }}
              >
                {application.clientId}
              </Text>
            </Form.Item>
          )}

          {/* secrets info (read-only, edit mode only) */}
          {application && (
            <div
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: 4,
                padding: 12,
                background: "#fafafa",
                marginTop: 8,
                fontFamily: "Inter",
                fontSize: 13,
              }}
            >
              <p className="mb-1">
                <strong>Primary Secret:</strong>{" "}
                {application.hasPrimarySecret
                  ? `****${application.primarySecretLast4 || ""}`
                  : "Not created"}
              </p>

              <p className="mb-0">
                <strong>Secondary Secret:</strong>{" "}
                {application.hasSecondarySecret
                  ? `****${application.secondarySecretLast4 || ""}`
                  : "Not created"}
              </p>
            </div>
          )}

          {/* info note for new applications */}
          {!application && (
            <div
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: 4,
                padding: 12,
                background: "#fafafa",
                marginTop: 8,
                fontFamily: "Inter",
                fontSize: 13,
              }}
            >
              <p className="mb-0">
                <strong>Note:</strong> Client ID and Secrets will be generated
                after application creation.
              </p>
            </div>
          )}
        </Form>
      </Spin>
    </Drawer>
  );
};

export default ApplicationDrawer;
